/*!
 * Copyright (c) 2019 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/Desktop/Transmute/vc-greeting-card/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('crypto-ld'),
    LDKeyPair = _require.LDKeyPair;

var X25519KeyPair = require('x25519-key-pair');
/**
 * Returns a `did:key` method DID Document for a given DID.
 * Note: This is async only to match the async `get()` signature of other
 * `did-io` drivers.
 *
 * @param {string} did
 * @returns {Promise<DidDocument>}
 * @throws Unsupported Fingerprint Type.
 * @throws Cannot get - missing DID.
 */


function get() {
  return _get.apply(this, arguments);
}
/**
 * Generates a new `did:key` method DID Document for a given key type.
 *
 * @param {string} [keyType='Ed25519VerificationKey2018']
 * @returns {Promise<DidDocument>}
 */


function _get() {
  _get = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _ref,
        did,
        fingerprint,
        publicKey,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, did = _ref.did;

            if (did) {
              _context.next = 3;
              break;
            }

            throw new Error('Cannot get - missing DID.');

          case 3:
            fingerprint = did.substr('did:key:'.length);
            publicKey = LDKeyPair.fromFingerprint({
              fingerprint: fingerprint
            });
            return _context.abrupt("return", keyToDidDoc(publicKey));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _get.apply(this, arguments);
}

function generate() {
  return _generate.apply(this, arguments);
}
/**
 * Converts an Ed25519KeyPair object to a `did:key` method DID Document.
 *
 * @param {Ed25519KeyPair} edKey
 * @returns {DidDocument}
 */


function _generate() {
  _generate = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var _ref2,
        _ref2$keyType,
        keyType,
        publicKey,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref2$keyType = _ref2.keyType, keyType = _ref2$keyType === void 0 ? 'Ed25519VerificationKey2018' : _ref2$keyType;
            _context2.next = 3;
            return LDKeyPair.generate({
              type: keyType
            });

          case 3:
            publicKey = _context2.sent;
            return _context2.abrupt("return", keyToDidDoc(publicKey));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _generate.apply(this, arguments);
}

function keyToDidDoc(edKey) {
  var did = "did:key:".concat(edKey.fingerprint());
  edKey.controller = did;
  var dhKey = X25519KeyPair.fromEdKeyPair(edKey);
  dhKey.id = "".concat(did, "#").concat(dhKey.fingerprint());
  return {
    '@context': 'https://w3id.org/did/v1',
    id: did,
    publicKey: [{
      id: did,
      type: edKey.type,
      controller: did,
      publicKeyBase58: edKey.publicKeyBase58
    }],
    authentication: [did],
    assertionMethod: [did],
    capabilityDelegation: [did],
    capabilityInvocation: [did],
    keyAgreement: [{
      id: dhKey.id,
      type: dhKey.type,
      controller: did,
      publicKeyBase58: dhKey.publicKeyBase58
    }]
  };
}

module.exports = {
  get: get,
  generate: generate,
  keyToDidDoc: keyToDidDoc
};